import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('post', `/api/live_discussions/${id}/publish`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/publishLiveDiscussion.js